module.exports = __webpack_public_path__ + "img/symbol_6.ef77656b.png";